import { useEffect, useState } from 'react';

export function useInViewOnce(ref, {
  rootMargin = '0px 0px -10% 0px',
  threshold = 0.15,
  disabled = false,
} = {}) {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (disabled) return undefined;
    if (inView) return undefined;
    const el = ref?.current;
    if (!el) return undefined;

    const prefersReducedMotion = typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      setInView(true);
      return undefined;
    }

    const obs = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setInView(true);
          obs.disconnect();
        }
      },
      { root: null, rootMargin, threshold },
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, rootMargin, threshold, disabled, inView]);

  return inView;
}

